import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

const LockProgressIcon = (props) => (
  <Svg width={28} height={28} viewBox="0 0 28 28" fill="none">
    <Circle
      cx={14}
      cy={14}
      r={14}
      fill={props?.color ? props.color : "#D9D9D9"}
    />
    <Path
      d="M17.6875 13.04V10.9844C17.6875 9.08687 16.1475 7.54688 14.25 7.54688C12.3525 7.54688 10.8125 9.08687 10.8125 10.9844V13.04C9.795 13.5487 9.09375 14.5869 9.09375 15.7969V17.8594C9.09375 19.5644 10.4825 20.9531 12.1875 20.9531H16.3125C18.0175 20.9531 19.4062 19.5644 19.4062 17.8594V15.7969C19.4062 14.5869 18.705 13.5487 17.6875 13.04ZM14.9375 17.1719C14.9375 17.55 14.6281 17.8594 14.25 17.8594C13.8719 17.8594 13.5625 17.55 13.5625 17.1719V16.4844C13.5625 16.1062 13.8719 15.7969 14.25 15.7969C14.6281 15.7969 14.9375 16.1062 14.9375 16.4844V17.1719ZM16.3125 12.7031H12.1875V10.9844C12.1875 9.85 13.1156 8.92188 14.25 8.92188C15.3844 8.92188 16.3125 9.85 16.3125 10.9844V12.7031Z"
      fill={props?.innerColor ? props.innerColor : "#808080"}
    />
  </Svg>
);

export default LockProgressIcon;
